import {
	PHARMACY_PATIENT_PRESCRIPTION_DETAILS_REQUEST,
	PHARMACY_PATIENT_PRESCRIPTION_DETAILS_SUCCESS,
	PHARMACY_PATIENT_PRESCRIPTION_DETAILS_FAILURE
} from '../../../constants';

const initialState = {
	data: null,
	loading: false,
	error: null,
};

const patientPrescriptionDetailsReducer = (state = initialState, action) => {
	switch (action.type) {
		case PHARMACY_PATIENT_PRESCRIPTION_DETAILS_REQUEST:
			return {
				...state,
				loading: true,
				// data: null,
				error: null,
			};
		case PHARMACY_PATIENT_PRESCRIPTION_DETAILS_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			};
		case PHARMACY_PATIENT_PRESCRIPTION_DETAILS_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: null,
			};
		default:
			return state;
	}
};

export default patientPrescriptionDetailsReducer;
